import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatNativeDateModule, MatButtonModule, MatCardModule, MatSnackBarModule, MatIconModule } from '@angular/material';
import 'hammerjs';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, Http } from '@angular/http';
import {ProductsService} from './services/products.service';
import {DoctorService} from './services/doctor.service';
import {AdoptionService} from './services/adoption.service';
import {CartService} from './services/cart.service';
import {CommonService} from './services/common.service'
import {Routing } from './app.routing';
import {Location, CommonModule} from '@angular/common';
import { SignupComponent } from './authentication/signup/signup.component';
import { SigninComponent } from './authentication/signin/signin.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { HomeComponent } from './home/home.component';
import { AuthService } from './authentication/auth.service';
import { AuthGuard } from './authentication/auth.guard';

import { RazorpayService } from './PaymentGateway/razorpay/razorpay.service';
import { PaytmComponent } from './PaymentGateway/paytm/paytm.component';
import { BlogService } from './services/blog.service';
import { FrgtpwdComponent } from './authentication/frgtpwd/frgtpwd.component';
import { DoctorloginComponent } from './authentication/doctorlogin/doctorlogin.component';
import { LogintypeComponent } from './authentication/logintype/logintype.component';
import { OtpconfirmationComponent } from './otpconfirmation/otpconfirmation.component';


import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { VetsComponent } from './vets/vets.component';
import { ServiceProviderAuthGuard } from './authentication/serviceproviderauth.guard';
import { MitterService } from './services/mitter.service';
import { DoctorchatrequestComponent } from './doctorchatrequest/doctorchatrequest.component';
import { UserchatrequestComponent } from './userchatrequest/userchatrequest.component';
import { PoliciesComponent } from './policies/policies.component';
import { NestService } from './services/nest.service';
import { WindowRef } from './PaymentGateway/windowref.service';
import { NgxLoadingModule } from 'ngx-loading';
import { SharedModule } from './common/shared.module';
import { PLATFORM_ID, APP_ID, Inject } from '@angular/core';
import { isPlatformBrowser ,isPlatformServer} from '@angular/common';
import { FilterModule } from './filter/filter.module';
import {SlideshowModule} from 'ng-simple-slideshow';
@NgModule({
  declarations: [
    AppComponent,
     SignupComponent,
    SigninComponent,
    HomeComponent,
    PaytmComponent,
    FrgtpwdComponent,
    DoctorloginComponent,
    LogintypeComponent,
    OtpconfirmationComponent,
    PagenotfoundComponent,
    VetsComponent,
    DoctorchatrequestComponent,
    UserchatrequestComponent,
    PoliciesComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'petcart' }),
    SharedModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    FormsModule,
    HttpModule,
    Routing,
    NgbModule.forRoot(),
     MatNativeDateModule,
     ReactiveFormsModule,
     NgxLoadingModule.forRoot({}),
     MatButtonModule,MatCardModule,MatSnackBarModule,
     MatIconModule,
     FilterModule,
     SlideshowModule
   ],
  providers: [ProductsService, CartService, Location, CommonService, AuthService, MitterService,
    AuthGuard, DoctorService, AdoptionService, BlogService, WindowRef, RazorpayService, ServiceProviderAuthGuard, NestService],
  bootstrap: [AppComponent],
  entryComponents: [ OtpconfirmationComponent, DoctorchatrequestComponent,PoliciesComponent],
})
export class AppModule { 
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(APP_ID) private appId: string) {}
    ngOnInit() {
      if (isPlatformBrowser(this.platformId)) {
        // Client only code.
     }
     if (isPlatformServer(this.platformId)) {
       // Server only code.
     }
  }
}
